import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, Award } from "lucide-react";
import { ABOUT } from "../../mock/mock";
import { useReveal } from "../../hooks/useReveal";

export default function About() {
  const ref = useReveal();
  return (
    <section className="py-20 lg:py-28 bg-homi-light">
      <div ref={ref} className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div className="reveal relative">
          <div className="rounded-3xl overflow-hidden shadow-xl">
            <img src={ABOUT.image} alt="About EMB" className="w-full h-[460px] object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-6 bg-homi-gold text-homi-black rounded-2xl shadow-xl px-8 py-6 text-center hidden md:block">
            <Award className="w-8 h-8 mx-auto mb-2" />
            <p className="font-heading font-extrabold text-3xl leading-none">{ABOUT.experience.value}</p>
            <p className="text-sm mt-1">{ABOUT.experience.label}</p>
          </div>
        </div>
        <div className="reveal" style={{ transitionDelay: "120ms" }}>
          <span className="homi-section-tag text-homi-goldDark text-sm">{ABOUT.tag}</span>
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl text-homi-black mt-3 mb-5 leading-tight">{ABOUT.title}</h2>
          <p className="text-lg text-homi-body leading-relaxed mb-8">{ABOUT.desc}</p>
          <div className="grid sm:grid-cols-2 gap-4 mb-9">
            {ABOUT.points.map((p) => (
              <div key={p} className="flex items-center gap-3">
                <CheckCircle2 className="w-6 h-6 text-homi-gold shrink-0" />
                <span className="font-medium text-homi-black">{p}</span>
              </div>
            ))}
          </div>
          <Link to="/homi/about" className="homi-btn-shine inline-flex items-center gap-2 bg-homi-gold hover:bg-homi-goldDark text-homi-black font-heading font-bold px-7 py-4 rounded-lg transition-colors">
            More About Us <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
